import React, { useState } from 'react';

interface FindReplaceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFind: (text: string) => boolean;
  onReplace: (findText: string, replaceText: string) => void;
  onReplaceAll: (findText: string, replaceText: string) => void;
}

export const FindReplaceModal: React.FC<FindReplaceModalProps> = ({ isOpen, onClose, onFind, onReplace, onReplaceAll }) => {
  const [findText, setFindText] = useState('');
  const [replaceText, setReplaceText] = useState('');
  const [error, setError] = useState<string | null>(null);

  if (!isOpen) return null;

  const handleFind = () => {
      setError(null);
      if (!findText) return;
      const found = onFind(findText);
      if (!found) setError(`No matches found for "${findText}"`);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none">
      <div className="bg-white p-5 rounded-lg shadow-2xl border border-gray-300 w-full max-w-sm pointer-events-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold text-gray-800">Find and Replace</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">✕</button>
        </div>

        {error && <div className="mb-3 text-xs text-red-600 bg-red-50 p-2 rounded border border-red-100">{error}</div>}
        
        <div className="space-y-3">
          <div>
            <label className="block text-xs font-bold text-gray-600 mb-1">Find</label>
            <input
              type="text"
              autoFocus
              placeholder="Search in sheet..."
              className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-green-500 outline-none text-sm"
              value={findText}
              onChange={(e) => setFindText(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleFind()}
            />
          </div>
          
          <div>
            <label className="block text-xs font-bold text-gray-600 mb-1">Replace with</label>
            <input
              type="text"
              placeholder="Replacement text..."
              className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-green-500 outline-none text-sm"
              value={replaceText}
              onChange={(e) => setReplaceText(e.target.value)}
            />
          </div>

          <div className="grid grid-cols-2 gap-2 mt-4 pt-2">
            <button onClick={handleFind} className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 font-medium transition text-sm border border-gray-300">
              Find Next
            </button>
            <button onClick={() => { setError(null); onReplace(findText, replaceText); }} className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 font-medium transition text-sm border border-gray-300">
              Replace
            </button>
            <button onClick={() => { setError(null); onReplaceAll(findText, replaceText); }} className="col-span-2 px-3 py-1.5 bg-blue-50 text-blue-700 border border-blue-200 rounded hover:bg-blue-100 font-medium shadow-sm transition text-sm">
              Replace All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};